import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with the publishable key from environment variables
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

/**
 * StripeWrapper component that provides Stripe context to its children
 * This wrapper initializes Stripe and makes it available to any child components
 * that need to use Stripe Elements or other Stripe functionality
 */
const StripeWrapper = ({ children }) => {
  // Options for Stripe Elements
  const options = {
    fonts: [
      {
        cssSrc: 'https://fonts.googleapis.com/css?family=Nunito:400,600,700',
      },
    ],
    locale: 'en',
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#E94057',
        colorBackground: '#ffffff',
        colorText: '#2D3142',
        colorDanger: '#D13046',
        fontFamily: 'Nunito, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px',
      },
    },
  };

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  );
};

export default StripeWrapper;
